<ng-content></ng-content>
<button
  mat-icon-button
  type="button"
  [matMenuTriggerFor]="colorMenu"
  [attr.aria-label]="toolTip"
  class="color-swatch-button"
  [style.background-color]="currentPillColor.bg"
  [style.color]="currentPillColor.text"
  [matTooltip]="toolTip"
></button>
<mat-menu #colorMenu="matMenu">
  <div
    class="color-grid"
    [ngClass]="tagLabel ? '' : 'no-label'"
    (click)="$event.stopPropagation()"
  >
    @for (pillKey of pillKeys; track pillKey) {
      @if (pillColors[pillKey]; as c) {
        <button
          class="color-swatch"
          [class.selected]="selectedColor === pillKey"
          [style.background-color]="c.bg"
          [style.color]="c.text"
          [attr.aria-label]="c.name"
          (click)="onColorSelect(pillKey)"
        >
          @if (selectedColor === pillKey) {
            <mat-icon>check</mat-icon>
          }
          <span class="swatch-label">{{ tagLabel || c.name }}</span>
        </button>
      }
    }
  </div>
</mat-menu>
